import { Logout } from '@mui/icons-material'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PageIndex } from '../../store/redux/reducers/pageNameSlice'
import { StyledContainerRowBetween, StyledContainerRowCenter } from '../../styles/ContainerStyles'
import { StyledListItemButton } from '../../styles/SidebarStyles'
import DarkModeButton from '../Button/DarkModeButton'
import { useSidebarLanguage } from './hooks/useSidebarLanguage'
import SidebarLink from './SidebarLink'

type SidebarFooterProps = {
  open: boolean
  onLogout: () => void
}

const SidebarFooter = ({ open, onLogout }: SidebarFooterProps) => {
  const { t } = useTranslation()
  const { changeLanguage } = useSidebarLanguage()

  return (
    <Box>
      <Stack
        direction="column"
        justifyContent="center"
        gap={0.5}
        sx={{ width: '100%', justifyContent: 'center', alignItems: open ? 'left' : 'center' }}
      >
        {!open && (
          <>
            <Tooltip title={t('language')} placement="right">
              <StyledListItemButton onClick={changeLanguage} sx={{ p: 1 }}>
                <Typography
                  variant="button"
                  sx={{
                    color: 'text.base',
                    cursor: 'pointer',
                    '&:hover': { textDecoration: 'underline' },
                    display: 'inline-block',
                  }}
                >
                  {t('languageShort')}
                </Typography>
              </StyledListItemButton>
            </Tooltip>
            <StyledContainerRowCenter>
              <DarkModeButton />
            </StyledContainerRowCenter>
          </>
        )}

        <SidebarLink
          open={open}
          Icon={Logout}
          text={t('components.sidebar.sidebarLogout')}
          action={onLogout}
          index={PageIndex.LOGOUT}
          standard
          aria-label={t('components.sidebar.sidebarLogout')}
        />
      </Stack>

      {open && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'left',
            pt: 2,
          }}
        >
          <Box sx={{ width: '100%', height: '1px', bgcolor: 'background.elevation8', mb: 1 }} />
          <StyledContainerRowBetween>
            <StyledContainerRowCenter>
              <DarkModeButton />
            </StyledContainerRowCenter>
            <Box sx={{ height: '30px', width: '4px', bgcolor: 'background.elevation8' }} />
            <Box
              sx={{
                width: '90%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <StyledListItemButton onClick={changeLanguage} sx={{ p: 0 }}>
                <Typography
                  aria-label={'Toggle Language'}
                  variant="button"
                  sx={{ color: 'text.base', display: 'inline-block' }}
                >
                  {t('language')}
                </Typography>
              </StyledListItemButton>
            </Box>
          </StyledContainerRowBetween>
        </Box>
      )}
    </Box>
  )
}

export default SidebarFooter
